<template>
  <div class="questionCmpContainer bounce"> 
    <questionCmp :qNumber="questionNumber" :qDetails="questionDetails[questionNumber]"></questionCmp>
  </div>
</template>

<script>
import questionData from '../../assets/json/questions.json'
export default {
  data() {
    return {
      questionNumber: 'five',
      questionDetails: questionData
    }
  }
}
</script>

<style scoped>
  .questionCmpContainer:before {
    content: '';
    position:absolute;
    display: block;
    top: 0; left:0; width:100%; height:100%;
    background-image: url('../../assets/images/characters/The-Wasp-bg.png');
  }
</style>
